import React, { Component } from 'react'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import parseSnapshot from '../../helpers/parseSnapshot'
import { db } from '../../config/firebaseconfig'
import { UsernameCSVsManage } from './UploadCSVComponents';

/**
 * Manages state for UsernameCSVsManage, which allows
 * the super admin to download usernames related to
 * past bulk uploads.
 */
class UsernameCSVsManageContainer extends Component {

  state = {
    assessmentName: '',
    error: false,
    loading: false,
    loadingComplete: false,
    schoolName: '',
  }
  
  componentDidMount() {
    const route = this.parseRoute()
    const {recordId, recordType, assessmentId, year} = route
    this.setState({loading: true})
    const fetchCSVs = db.collection('usernameCSVs')
      .where('recordId', '==', recordId)
      .where('assessmentId', '==', assessmentId)
      .where('year', '==', year)
      .get()
      .then(querySnapshot => {
        this.csvData = parseSnapshot(querySnapshot)
      })


    const fetchSchoolName = db.collection('schools').doc(recordId).get()
      .then(doc => {
        if (doc.exists) {
          this.setState({schoolName: doc.data().name})
        }
      })
    
    const fetchAssessmentName = db.collection('sets').doc(assessmentId).get()
      .then(doc => {
        if (doc.exists) {
          this.setState({assessmentName: doc.data().displayName})
        }
      })

    Promise.all([fetchCSVs, fetchSchoolName, fetchAssessmentName])
      .then(() => {
        this.setState({loading: false, loadingComplete: true})
      })
      .catch(err => {
        console.log(err)
        this.setState({loading: false, error: true})
      })

  }

  parseRoute = () => {
    const { match, location } = this.props
    const { params } = match
    const { recordId, recordType } = params
    const { search } = location
    const query = search && queryString.parse(search)
    const assessmentId = query.a
    const year = query.sy
    return {recordId, recordType, assessmentId, year, search}
  }

  linkToUpload = () => {
    const { recordId, recordType, search } = this.parseRoute()
    const BASE_LINK = '/assessment/upload/'
    const ROUTE = `${recordType}/${recordId}`
    return `${BASE_LINK}${ROUTE}${search}`
  }
  
  render() {
    const { loading, loadingComplete, error, schoolName, assessmentName } = this.state
    const { csvData, parseRoute, linkToUpload } = this
    const { year } = parseRoute()

    return (
      <UsernameCSVsManage 
        loading={loading}
        loadingComplete={loadingComplete}
        error={error}
        csvData={csvData && Object.values(csvData)}
        schoolName={schoolName}
        year={year}
        assessmentName={assessmentName}
        error={error}
        linkToUpload={linkToUpload()}
      />
    )
  }
}

const { object } = PropTypes
UsernameCSVsManageContainer.propTypes = {
  history: object,
  location: object.isRequired,
  match: object.isRequired,
}

export default UsernameCSVsManageContainer


// WEBPACK FOOTER //
// ./src/components/Assessment/UsernameCSVsManageContainer.js